'use client'

import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@mentora/ui-components'
import { Eye } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { TransactionDetailsLoader } from './transaction-details-loader'

// The Transactions list's way into one transaction: an eye button at the end
// of the row opens a dialog with everything the details page shows, and the
// refund / cancel actions with it. The content mounts — and so loads the
// transaction — only while the dialog is open.

export function TransactionDetailsDialog({ kind, id, label, listCurrency }: {
  kind: 'course' | 'event' | 'membership'
  id: string
  /** Who and what, for the button's accessible name. */
  label: string
  /** The storefront's list currency (`usd`, `brl`). */
  listCurrency: string
}) {
  const t = useTranslations('transactions')
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={t('view', { label })}
          title={t('view', { label })}
          data-testid={`transaction-view-${kind}-${id}`}
        >
          <Eye className="size-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t('details.title')}</DialogTitle>
          <DialogDescription>{label}</DialogDescription>
        </DialogHeader>
        <TransactionDetailsLoader kind={kind} id={id} listCurrency={listCurrency} />
        <Link href={`/admin/transactions/${kind}/${id}`} className="text-sm text-muted-foreground underline-offset-4 hover:text-foreground hover:underline">
          {t('dialog.openPage')}
        </Link>
      </DialogContent>
    </Dialog>
  )
}
